import React, { createContext, useState } from 'react';
import axios from 'axios';

export const UserContext = createContext();

const LOGIN_EXPIRY_MS = 12 * 60 * 60 * 1000;

const clearSavedUser = () => {
  localStorage.removeItem('edugroove_user');
  localStorage.removeItem('edugroove_login_saved_at');
  localStorage.removeItem('currentLoginLogId');
  localStorage.removeItem('edugroove_access_token');
  delete axios.defaults.headers.common.Authorization;
};

const getSavedUser = () => {
  try {
    const savedUser = localStorage.getItem('edugroove_user');
    const savedAt = Number(localStorage.getItem('edugroove_login_saved_at'));

    if (!savedUser || !savedAt) {
      clearSavedUser();
      return null;
    }

    const isExpired = Date.now() - savedAt > LOGIN_EXPIRY_MS;

    if (isExpired) {
      clearSavedUser();
      return null;
    }

    const token = localStorage.getItem('edugroove_access_token');
    if (!token) { clearSavedUser(); return null; }
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    return JSON.parse(savedUser);
  } catch (err) {
    console.warn('Could not restore saved EDU Groove user:', err);
    clearSavedUser();
    return null;
  }
};

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUserState] = useState(getSavedUser);

  const saveCurrentUser = (userData) => {
    setCurrentUserState(userData);

    if (userData) {
      localStorage.setItem('edugroove_user', JSON.stringify(userData));
      localStorage.setItem('edugroove_login_saved_at', String(Date.now()));
    } else {
      clearSavedUser();
    }
  };

  return (
    <UserContext.Provider
      value={{
        currentUser,
        setCurrentUser: saveCurrentUser,
        saveCurrentUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
